import React, { useState } from 'react'

import PhoneIcon from 'presentation/assets/icons/phone-contact.svg'
import MailIcon from 'presentation/assets/icons/mail.svg'
import ArrowIcon from 'presentation/assets/icons/right-arrow.svg'

import * as S from './styles'
import { newRegistrationDetailsContext } from 'presentation/hospital/layouts/DoctorRegister/NewRegistrationsDetails/context'
import { translateRegistrationStepName } from 'domain/entities/overall-registration-status-model'
import { observer } from 'mobx-react'
import { formatPhone } from 'presentation/utils/masks'
import { DoctorRegisterStatus } from 'domain/entities/doctor-register'
import { StudyModality } from 'common/enum/study-modality'

type OverviewCardProps = {
  doctor: {
    name: string
    phone: string
    email: string
  }
  complement?: {
    academicFormation: string
    crm: string
    crmUf: string
    specialty: string
    isResident: boolean
    indicationDate?: string
    sendDocumentDate?: string
    registerInMvDate?: string
    modality?: StudyModality
  }
  units?: string[]
  actingSectors?: string[]
}

const OverviewCard = observer(
  ({ doctor, complement, units, actingSectors }: OverviewCardProps) => {
    const [isCollapsed, setIsCollapsed] = useState(false)

    const pendencies = () => {
      return newRegistrationDetailsContext.pendencies.map((pendency) => {
        if (pendency?.name) {
          return translateRegistrationStepName(pendency.name)
        }
        return ''
      })
    }

    const reviews = () => {
      return newRegistrationDetailsContext.toReview.map((review) => {
        if (review?.name) {
          return translateRegistrationStepName(review.name)
        }
        return ''
      })
    }

    const hasPendency = () => {
      return newRegistrationDetailsContext.pendencies.length > 0
    }

    const hasReview = () => {
      return newRegistrationDetailsContext.toReview.length > 0
    }

    const showPendencies = () => {
      if (!newRegistrationDetailsContext.isDirector) return true
    }

    const showReviews = () => {
      if (newRegistrationDetailsContext.isDirector) return true

      return (
        newRegistrationDetailsContext.register?.status ===
          DoctorRegisterStatus.REVIEWED_BY_DIRECTOR && hasReview()
      )
    }

    return (
      <S.Wrapper isCollpased={isCollapsed}>
        <S.Header isCollpased={isCollapsed}>
          <section>
            <S.Name>{doctor.name}</S.Name>
            <img src={ArrowIcon} onClick={() => setIsCollapsed(!isCollapsed)} />
          </section>
          <S.Contact>
            <img src={PhoneIcon} />
            <label>{formatPhone(doctor.phone)}</label>
          </S.Contact>
          <S.Contact>
            <img src={MailIcon} />
            <label>{doctor.email}</label>
          </S.Contact>
        </S.Header>
        {showPendencies() && (
          <S.Pendencies>
            <S.PendenciesTitle>Pendências</S.PendenciesTitle>
            <S.PendenciesContent>
              {!hasPendency() && 'Nenhuma pendência'}
              {pendencies().map((pendency, idx) => (
                <S.Pendency key={idx}>{pendency}</S.Pendency>
              ))}
            </S.PendenciesContent>
          </S.Pendencies>
        )}
        {showReviews() && (
          <S.Pendencies>
            <S.PendenciesTitle>Revisões</S.PendenciesTitle>
            <S.PendenciesContent>
              {!hasReview() && 'Nenhuma revisão'}
              {reviews().map((review, index) => (
                <S.Pendency key={index}>{review}</S.Pendency>
              ))}
            </S.PendenciesContent>
          </S.Pendencies>
        )}

        {complement && (
          <S.Complement>
            <S.ComplementItem>
              {`${complement?.academicFormation} | ${complement.crm} - ${complement.crmUf}`}
            </S.ComplementItem>
            <S.ComplementItem>
              {complement.modality &&
                (complement.modality === StudyModality.RESIDENT
                  ? 'Residente | '
                  : 'Especializando | ')}
              {complement.specialty}
            </S.ComplementItem>
            <S.ComplementItem>
              DATA DE INDICAÇÃO:{' '}
              {complement.indicationDate ? complement.indicationDate : '-'}
            </S.ComplementItem>
            <S.ComplementItem>
              DATA DE ENVIO DA DOCUMENTAÇÃO:{' '}
              {complement.sendDocumentDate ? complement.sendDocumentDate : '-'}
            </S.ComplementItem>
            <S.ComplementItem>
              DATA DE CADASTRO NO MV:
              {complement.registerInMvDate ? complement.registerInMvDate : '-'}
            </S.ComplementItem>
          </S.Complement>
        )}
        <S.Units>
          <S.UnitsTitle>Unidades de atuação</S.UnitsTitle>
          <ul>
            {units &&
              units.map((unit, idx) => <S.Unit key={idx}>{unit}</S.Unit>)}
          </ul>
        </S.Units>
        <S.ActingSectors>
          <S.ActingSectorsTitle>Setor de atuação</S.ActingSectorsTitle>
          <ul>
            {actingSectors &&
              actingSectors.map((sector, idx) => (
                <S.ActingSector key={idx}>{sector}</S.ActingSector>
              ))}
          </ul>
        </S.ActingSectors>
      </S.Wrapper>
    )
  }
)

export default OverviewCard
